import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { FeatureFlagService } from '../feature-flag.service';
import { LogService } from '../services/log.service';

@Directive({
    selector: '[myRemoveIfFeatureOff]'
})
export class MyRemoveIfFeatureOffDirective implements OnInit {
    @Input('myRemoveIfFeatureOff') featureName: string;

    constructor(private el: ElementRef,
        private logger: LogService,
        private featureFlagService: FeatureFlagService) {
    }

    ngOnInit() {
        this.logger.info(this.featureName, this.featureFlagService.featureOff(this.featureName))
        if (this.featureFlagService.featureOff(this.featureName)) {
            this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
        }
    }
}